<template>
  <v-card
    v-if="expediente"
    class="card"
    color="primary"
  >
    <v-card-title>
      <div class="text-h6 font-weight-bold">
        Información del evaluado
      </div>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row align="center">
          <v-col cols="3">
            <v-img
              v-if="expediente.Personal.foto !== ''"
              :src="expediente.Personal.foto"
              width="120"
            />
            <v-avatar
              v-else
              color="secondary"
              rounded
              size="80"
            >
              <v-icon
                size="64"
                color="white"
              >
                mdi-account
              </v-icon>
            </v-avatar>
          </v-col>
          <v-col cols="9">
            <v-row>
              <v-col cols="2">
                <div class="text-caption">
                  Folio de expediente
                </div>
                <div class="text-subtitle-1 font-weight-bold">
                  {{ expediente.folio }}
                </div>
              </v-col>
              <v-col cols="10">
                <div class="text-caption">
                  Nombre
                </div>
                <div class="text-subtitle-1 font-weight-bold">
                  {{ getFullName(expediente.Personal) }}
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <div class="text-caption">
                  Edad
                </div>
                <div class="text-subtitle-1 font-weight-bold">
                  {{ getAge(expediente.Personal.fechaNacimiento) }} años
                </div>
              </v-col>
              <v-col>
                <div class="text-caption">
                  Fecha de nacimiento
                </div>
                <div class="text-subtitle-1 font-weight-bold">
                  {{ expediente.Personal.fechaNacimiento }}
                </div>
              </v-col>
              <v-col>
                <div class="text-caption">
                  Sexo
                </div>
                <div
                  v-if="expediente.Personal.CatSexo"
                  class="text-subtitle-1 font-weight-bold"
                >
                  {{ expediente.Personal.CatSexo.title }}
                </div>
                <div
                  v-else
                  class="text-subtitle-1 font-weight-bold"
                >
                  No registrado
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  props: {
    expediente: {
      type: Object,
      required: true,
    },
  },
};
</script>
